import React from "react";

type SyslogProps = {
  size?: string;
};

const Syslog = ({ size = "32px" }: SyslogProps) => {
  const color = "var(--icon-ebony-light-stroke,var(--ebony-light))";
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 24V8H19V10C19 10.5272 19.1801 11.0443 19.5679 11.4321C19.9557 11.8199 20.4728 12 21 12H23V24H9ZM23 10V8H21V10H23ZM9 6C8.47275 6 7.95567 6.18011 7.56789 6.56789C7.18011 6.95567 7 7.47275 7 8V24C7 24.5272 7.18011 25.0443 7.56789 25.4321C7.95567 25.8199 8.47275 26 9 26H23C23.5272 26 24.0443 25.8199 24.4321 25.4321C24.8199 25.0443 25 24.5272 25 24V8C25 7.47275 24.8199 6.95567 24.4321 6.56789C24.0443 6.18011 23.5272 6 23 6H9ZM11 17C11 16.4477 11.4477 16 12 16H20C20.5523 16 21 16.4477 21 17C21 17.5523 20.5523 18 20 18H12C11.4477 18 11 17.5523 11 17ZM12 20C11.4477 20 11 20.4477 11 21C11 21.5523 11.4477 22 12 22H20C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20H12Z"
        fill={color}
      />
    </svg>
  );
};

export default Syslog;
